import { SET_MENU_VISIBILITY } from 'actions/constants';
import { dispatch, getStore } from 'controllers/controller';

export const toggleMenu = () => {
  const isMenuOpen = getStore().user.isMenuOpen;

  dispatch({
    type: SET_MENU_VISIBILITY,
    isMenuOpen: !isMenuOpen,
  });
};
